export default "__VITE_ASSET__BcATFDW9__"